export const navItems = [
    ['About', 'about'], 
    ['Career', 'career'], 
    ['Education', 'education'],
    ['Expertise', 'expertise'], 
    ['Projects', 'projects'], 
    // ['Contact', 'contact']
];
